
import { RouteConfig } from './types';
import { lazy } from 'react';

// Lazy load heavy components
const Leads = lazy(() => import('../pages/Leads'));
const LeadDetailPage = lazy(() => import('../pages/leads/LeadDetail'));
const EditLead = lazy(() => import('../pages/leads/EditLead'));
const AddLead = lazy(() => import('../pages/leads/AddLead'));
const Contacts = lazy(() => import('../pages/leads/Contacts'));
const AddContact = lazy(() => import('../pages/leads/AddContact'));
const FindLeads = lazy(() => import('../pages/leads/FindLeads'));
const AILeadSearch = lazy(() => import('../pages/AILeadSearch'));
const LeadAnalytics = lazy(() => import('../pages/leads/LeadAnalytics'));
const ImportLeads = lazy(() => import('../pages/leads/ImportLeads'));
const ApolloCsvImport = lazy(() => import('../pages/leads/ApolloCsvImport'));
const LeadAssignment = lazy(() => import('../pages/leads/LeadAssignment'));
const SalesPipeline = lazy(() => import('../pages/leads/SalesPipeline'));
const LeadTimeline = lazy(() => import('../pages/leads/LeadTimeline'));

export const leadRoutes: RouteConfig[] = [
  { path: "/app/leads", element: Leads, requiresLayout: true, requiredPermissions: ['lead.read'] },
  { path: "/leads", element: Leads, requiresLayout: true, requiredPermissions: ['lead.read'] },
  // Specific routes MUST come before dynamic routes
  { path: "/app/leads/add", element: AddLead, requiresLayout: true, requiredPermissions: ['lead.create'] },
  { path: "/app/leads/new", element: AddLead, requiresLayout: true, requiredPermissions: ['lead.create'] },
  { path: "/leads/new", element: AddLead, requiresLayout: true, requiredPermissions: ['lead.create'] },
  { path: "/app/leads/contacts", element: Contacts, requiresLayout: true, requiredPermissions: ['contact.read'] },
  { path: "/leads/contacts", element: Contacts, requiresLayout: true, requiredPermissions: ['contact.read'] },
  { path: "/app/leads/contacts/new", element: AddContact, requiresLayout: true },
  { path: "/leads/contacts/new", element: AddContact, requiresLayout: true },
  { path: "/app/leads/find", element: FindLeads, requiresLayout: true, requiredPermissions: ['lead.read', 'external_api.read'] },
  { path: "/leads/find", element: FindLeads, requiresLayout: true, requiredPermissions: ['lead.read', 'external_api.read'] },
  { path: "/app/leads/analytics", element: LeadAnalytics, requiresLayout: true, requiredPermissions: ['lead.read', 'analysis.read'] },
  { path: "/leads/analytics", element: LeadAnalytics, requiresLayout: true, requiredPermissions: ['lead.read', 'analysis.read'] },
  { path: "/app/leads/import", element: ImportLeads, requiresLayout: true },
  { path: "/leads/import", element: ImportLeads, requiresLayout: true },
  { path: "/app/leads/import-apollo", element: ApolloCsvImport, requiresLayout: true, requiredPermissions: ['lead.create'] },
  { path: "/leads/import-apollo", element: ApolloCsvImport, requiresLayout: true, requiredPermissions: ['lead.create'] },
  { path: "/app/leads/assignment", element: LeadAssignment, requiresLayout: true, requiredPermissions: ['lead.update', 'user.read'] },
  { path: "/leads/assignment", element: LeadAssignment, requiresLayout: true, requiredPermissions: ['lead.update', 'user.read'] },
  { path: "/app/leads/pipeline", element: SalesPipeline, requiresLayout: true, requiredPermissions: ['leads_pipeline.read'] },
  { path: "/leads/pipeline", element: SalesPipeline, requiresLayout: true, requiredPermissions: ['leads_pipeline.read'] },
  // Dynamic routes MUST come after specific routes
  { path: "/app/leads/:id/timeline", element: LeadTimeline, requiresLayout: true },
  { path: "/leads/:id/timeline", element: LeadTimeline, requiresLayout: true },
  { path: "/app/leads/:id", element: LeadDetailPage, requiresLayout: true },
  { path: "/leads/:id", element: LeadDetailPage, requiresLayout: true },
  { path: "/app/leads/:id/edit", element: EditLead, requiresLayout: true },
  { path: "/leads/:id/edit", element: EditLead, requiresLayout: true },
  { path: "/app/ai-lead-search", element: AILeadSearch, requiresLayout: true, requiredPermissions: ['lead.read', 'ai.read'] },
  { path: "/ai-lead-search", element: AILeadSearch, requiresLayout: true, requiredPermissions: ['lead.read', 'ai.read'] }
];
